export default __webpack_public_path__ + "static/media/06_boruvky_d-min.68c7ebcb.jpg";